import { render, staticRenderFns } from "./Scale10BlocksPrioritets.vue?vue&type=template&id=17838fdf&scoped=true"
import script from "./Scale10BlocksPrioritets.vue?vue&type=script&lang=js"
export * from "./Scale10BlocksPrioritets.vue?vue&type=script&lang=js"
import style0 from "./Scale10BlocksPrioritets.vue?vue&type=style&index=0&id=17838fdf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17838fdf",
  null
  
)

export default component.exports